////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskEditSetup = {
	[ActionsTypes.GET_KIOSK_SETUP]: (state) =>
		update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: true,
				},
				itemDetail: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_SETUP_SUCCESS]: (state, payload) => {
		return update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				itemDetail: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_SETUP_FAILURE]: (state, payload) =>
		update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.PUT_EDIT_KIOSK_SETUP]: (state) =>
		update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.PUT_EDIT_KIOSK_SETUP_SUCCESS]: (state, _payload) => {
		return update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: '',
				},
			},
		})
	},
	[ActionsTypes.PUT_EDIT_KIOSK_SETUP_FAILURE]: (state, payload) =>
		update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.VIEW_PRODUCTION_FILE]: (state) =>
		update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.VIEW_PRODUCTION_FILE_SUCCESS]: (state, _payload) => {
		return update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: false,
				},
				/*   contractView: {
                      $set: true,
                  }, */
			},
		})
	},
	[ActionsTypes.VIEW_PRODUCTION_FILE_FAILURE]: (state, payload) => {
		return update(state, {
			kioskEditSetUp: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
}

export default kioskEditSetup
